// extracted by mini-css-extract-plugin
module.exports = {"navContainer":"Footer-module--navContainer--2hI58","navLink":"Footer-module--navLink--SohMb"};